import "../Custom.css"
import ServicesPage from "./ServicesPage"
import {
  CORP_SERVICE_PAGE_IMAGE_FOUR,
  CORP_SERVICE_PAGE_IMAGE_ONE,
  CORP_SERVICE_PAGE_IMAGE_THREE,
  CORP_SERVICE_PAGE_IMAGE_TWO,
  CORP_SERVICE_PAGE_IMAGE_FIVE,
} from "../utils/constants"

const CorporateService = () => {
  const leftColumnData = [
    {
      title: "Company Formation & Structuring",
      desc: "Launch and structure your business with confidence. We assist in setting up companies across Free Zone, Mainland, and Offshore jurisdictions, including holding companies and SPVs. Our experts provide strategic guidance on corporate governance to ensure your structure is optimized for growth and compliance.",
      imgPath: CORP_SERVICE_PAGE_IMAGE_ONE,
    },
    {
      title: "Nominee & Trustee Services",
      desc: "Safeguard your privacy and assets with our nominee and trustee services. We offer nominee shareholder and director arrangements, trust declarations, and confidentiality structures to support secure, discreet ownership. Our trustee services also enhance wealth planning and succession strategies.",
      imgPath: CORP_SERVICE_PAGE_IMAGE_TWO,
    },
  ]

  const rightColumnData = [
    {
      title: "Trust & Foundation Formation",
      desc: "Protect your legacy with tailored trust and foundation solutions. We specialize in setting up DIFC and RAK ICC trusts, as well as UAE and international foundations. Our services support estate planning, succession management, and robust asset protection frameworks.",
      imgPath: CORP_SERVICE_PAGE_IMAGE_THREE,
    },
    {
      title: "Compliance & Regulatory Support",
      desc: "Stay ahead of evolving regulations with our compliance advisory. We provide expert support in Anti-Money Laundering (AML), Know-Your-Customer (KYC), Ultimate Beneficial Owner (UBO) reporting, and Economic Substance Regulations (ESR) filing. Our team also handles VAT and Corporate Tax advisory, helping you maintain full regulatory compliance with minimal disruption.",
      imgPath: CORP_SERVICE_PAGE_IMAGE_FOUR,
    },
    {
      title: "Corporate Secretarial Services",
      desc: "Ensure smooth corporate operations with our end-to-end secretarial support. From drafting board resolutions and maintaining statutory records to handling annual filings and renewals, we act as your registered agent, ensuring your business remains compliant and well-organized.",
      imgPath: CORP_SERVICE_PAGE_IMAGE_FIVE,
    },
  ]

  return (
    <>
      <ServicesPage prop={{ leftColumnData, rightColumnData }} />
    </>
  )
}

export default CorporateService
